import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

// Obtenir les données de l'utilisateur depuis Firestore
export const getUserData = async (userId) => {
  if (!userId) return null;
  
  if (import.meta.env.MODE !== 'production') {
    console.log('[FIREBASE] Requête: getUserData', { userId });
  }
  try {
    const userDocRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      return userDoc.data();
    } else {
      // Si le document n'existe pas, créer un document utilisateur par défaut
      const defaultUserData = {
        userType: 'normal',
        createdAt: new Date().toISOString()
      };
      
      await setDoc(userDocRef, defaultUserData);
      return defaultUserData;
    }
  } catch (error) {
    console.error("Erreur lors de la récupération des données utilisateur:", error);
    // Retourner un objet par défaut en cas d'erreur
    return {
      userType: 'normal'
    };
  }
};

// Mettre à jour les données utilisateur
export const updateUserData = async (userId, updates) => {
  if (import.meta.env.MODE !== 'production') {
    console.log('[FIREBASE] Requête: updateUserData', { userId, updates });
  }
  try {
    const userDocRef = doc(db, 'users', userId);
    await updateDoc(userDocRef, updates);
    return { success: true };
  } catch (error) {
    console.error("Erreur lors de la mise à jour des données utilisateur:", error);
    throw error;
  }
};

// Mettre à jour l'utilisateur en admin
export const makeUserAdmin = async (userId) => {
  if (!userId) throw new Error('ID utilisateur requis');
  
  try {
    const userDocRef = doc(db, 'users', userId);
    
    // Vérifier si le document existe
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      // Document existe, mettre à jour
      await updateDoc(userDocRef, { userType: 'admin' });
    } else {
      // Document n'existe pas, le créer
      await setDoc(userDocRef, {
        userType: 'admin',
        createdAt: new Date().toISOString()
      });
    }
    
    return { success: true };
  } catch (error) {
    console.error("Erreur lors de la mise à jour du type d'utilisateur:", error);
    throw error;
  }
}; 